import { render, staticRenderFns } from "./TabTable.vue?vue&type=template&id=c1d4f67a&scoped=true&"
import script from "./TabTable.vue?vue&type=script&lang=js&"
export * from "./TabTable.vue?vue&type=script&lang=js&"
import style0 from "./TabTable.vue?vue&type=style&index=0&id=c1d4f67a&scoped=true&lang=css&"
import style1 from "./TabTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d4f67a",
  null
  
)

export default component.exports